import {ICrudLocale} from "../../../i18n/interface";

export const CENTER_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  CENTER_MANAGEMENT: {
    FIELD: {
      NAME: 'Nombre',
      DESCRIPTION: 'Descripción',
      ACTIVE: 'Activo',
      PROFESSIONALS: 'Profesionales',
      PATIENTS: 'Pacientes',
      TYPE: 'Tipo de centro',
      NUMBER_OF_LICENSES: 'Número de licencias',
      CONTACT_EMAIL: 'Email de la persona de contacto',
      CONTACT_NAME: 'Nombre de la persona de contacto',
      CONTACT_PHONE: 'Teléfono de la persona de contacto',
      PHONE: 'Teléfono',
      ADDRESS: 'Dirección',
    },
    TEXT: {
      STATE: 'Estado',
      CENTER_DATA: 'Datos del centro',
      ACTIVE: 'Activo',
      INACTIVE: 'Inactivo',
      CENTER_ACTIVE_DATA: 'Centro con datos activos',
      DELETE_MESSAGE: 'Si lo eliminas, todos los datos serán borrados.<br> <b>Esta acción no es reversible.</b>',
      DELETE_MESSAGE_ACTIVE_DATA: 'Este centro todavía tiene profesionales y/o pacientes activos. <b>Antes de eliminarlo, asegúrate de que no tenga usuarios activos.</b>'
    },

    LABEL: {
      SINGULAR: 'Centro',
      PLURAL: 'Centros',
    },
    LIST: {
      TITLE: 'Listado de centros'
    }
  }
}
